/**
 * DB 콘텐츠 번역 대상 언어 목록 (backend/src/dto.rs 의 CONTENT_LANGS 와 일치).
 * ko 원문은 기존 이름/설명 필드에 입력하므로 여기 포함하지 않는다.
 */
export const CONTENT_LANGS = ['en', 'zh-CN', 'zh-TW', 'ja', 'es', 'vi'] as const

export type ContentLang = (typeof CONTENT_LANGS)[number]

export const CONTENT_LANG_LABELS: Record<ContentLang, string> = {
  en: 'English',
  'zh-CN': '简体中文',
  'zh-TW': '繁體中文',
  ja: '日本語',
  es: 'Español',
  vi: 'Tiếng Việt',
}
